import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter,HashRouter } from 'react-router-dom';
import { AlertProvider } from './components/AlertProvider/AlertProvider';
// redux toolkit
import {Provider} from 'react-redux';
import store from './store';


// useEffect(() => {
//   var isBindFlag = false, isAuth = false, opendId = '', paramsArray = [];
//   /*
//    * 省略代码：地址判断，参数处理 赋值给isAuth, isBindFlag, openId
//    */ 
//   if (!isAuth) {							// 未授权
//     window.location.href=`https://open.weixin.qq.com/connect/oauth2/authorize?appid=${'xxxxxxx'}&redirect_uri=http://xxxxx/api/auth?response_type=code&scope=snsapi_userinfo&state=STATE&connect_redirect=1#wechat_redirect`;
//   } else if (!isBindFlag) {   // 未注册
//     window.location.href = '#/pages/login'
//   } else {               			// 登录
//     window.location.href = '#/pages/index'
//   }
// }, []);


const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <Provider store={store}>
    <AlertProvider>
      <HashRouter>
        <App />
      </HashRouter>
      </AlertProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
